

export const getReviews = (state) => state.reviews.reviews
export const getStarAverage = (state) => state.reviews.starAverage